import { makeStyles, Theme } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core';

const sidebarStyle = makeStyles((theme: Theme) => {
  return {
    root: {
      position: 'absolute',
      left: 0,
      top: 0,
      backgroundColor: theme.palette.text.primary,
      display: 'flex',
      minWidth: 270,
      width: 270,
      height: '100%',
      transition: 'all .15s',
      flexDirection: 'column',
      overflow: 'hidden',
      zIndex: 10,
      maxHeight: '100%',

      '& + .pageWrapper': {
        paddingLeft: 0,
      },

      [theme.breakpoints.up('desktop')]: {
        '& + .pageWrapper': {
          paddingLeft: 270,
        },
      },

      '&.sidebar--closed': {
        zIndex: 10,
        width: 0,
        minWidth: 0,

        '& + .pageWrapper': {
          paddingLeft: 0,
        },
        [theme.breakpoints.up('desktop')]: {
          width: '78px',
          minWidth: '78px',
          '& + .pageWrapper': {
            paddingLeft: 78,
          },
        },
        '&.scrollBox': {
          padding: theme.spacing(0, 1, 1, 1),
        },
      },
    },
    inactiveMenu: {
      pointerEvents: 'none',
    },
    sidebarContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: 1,
      minHeight: '0',
    },
    sidebarWrapper: {
      scrollbarGutter: 'stable',
      flex: 1,
      padding: '0 0 0 15px',
      margin: '8px 0 15px 0',
      '& > .sidebarContainer, .sidebarNavLink': {
        marginBottom: '1px',
      },
      '& > *:last-child': {
        marginBottom: '0',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: '#323232',
        marginTop: '-8px',
        marginBottom: '-15px',
      },
      '&::-webkit-scrollbar-thumb': {
        borderColor: '#323232',
        backgroundColor: 'rgba(140, 140, 140, 0.8)',
        '&:hover': {
          backgroundColor: 'rgba(140, 140, 140, 1)',
        },
      },
    },
    header: {
      borderBottom: `1px solid ${theme.palette.secondary.main}`,
      margin: '0 15px',
    },
    footer: {
      padding: '15px 5px',
      margin: '0 15px',
      borderTop: `1px solid ${theme.palette.secondary.main}`,
    },
    sidebarIconWrapper: {
      color: theme.palette.common.white,
      '& button:hover': {
        backgroundColor: alpha(theme.palette.text.secondary, 0.7),
      },
      '&:hover': {
        backgroundColor: alpha(theme.palette.text.secondary, 0.7),
      },
    },
  };
});

export default sidebarStyle;
